import styles from './license/license.module.css';
import { toSurePartUrl } from '../surepart-routing';

class EMSDistributorInstalled extends HTMLElement {
    public connectedCallback(): void {
        this.render();
    }

    public render(): void {
        this.innerHTML = `
            <div class="${styles.LoginWrapper}">
                <div class="${styles.Greetings}">
                    <h1 data-testid="congratulations" class=${styles.Header}>Congratulations!</h1>
                    <p>
                        You have successfully installed the SurePart EMS Distributor.
                        <br />
                        To view claims, please continue to SurePart by selecting the button below
                    </p>
                </div>
                <div class="${styles.Greetings}">
                    <a href="${toSurePartUrl('/')}" data-testid="button" type="button" class="${styles.buttonSecondary}">
                        <span data-testid="button-text">Back to Claims</span>
                        <span aria-hidden="true" data-testid="button-icon-right" tabindex="-1">
                            <svg viewBox="0 0 24 24" fill="none" width="16" height="16" data-testid="arrow-left-icon"><path d="M20 12H4M4 12L10 18M4 12L10 6" stroke="currentcolor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                            <div class="${styles.hidden}">Decorative icon</div>
                        </span>
                    </a>
                </div>
            </div>
        `;
    }
}

customElements.define('ems-distributor-installed-view', EMSDistributorInstalled);

export { EMSDistributorInstalled };
